import { isAuthToken } from '../../../../services/authToken';

export function agentRequestOptions(url, options = {}) {
    const headers = new Headers(options.headers || {});
    const token = localStorage.getItem('token_id');
    try {
        if (new URL(url).origin === new URL(process.env.REACT_APP_NODE_API_URL).origin && isAuthToken(token)) {
            headers.set('Authorization', 'Bearer ' + token);
        }
    } catch (_) {}
    return { ...options, headers };
}

export function requireAgentReply(res, data) {
    if (!res.ok || data?.result === 'error' || Number(data?.statusCode) >= 400 || data?.response === '400') {
        throw new Error(data?.error || data?.msg || data?.detail || 'The assistant API is unavailable. Please try again shortly.');
    }
    if (typeof data?.reply !== 'string' || !data.reply.trim()) {
        throw new Error('The assistant returned an empty response. Please try again shortly.');
    }
    return data;
}

